import CircularProgress from '@material-ui/core/CircularProgress';
import { CKButton } from 'clearkit';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import Error from './Error.svg';
import styles from './styles';

const GraphqlError = ({
  className,
  classes,
  refetch = window.location.reload,
  loading,
  error = {},
  inline,
}) => {
  if (isEmpty(error)) return null;

  const { networkError } = error;
  const backtrace = get(networkError, 'result.error.backtrace');
  const networkErrorMessage = get(error, 'networkError.result.error.message');

  const errors = error.graphQLErrors;

  const showDetails =
    (errors || networkErrorMessage || backtrace) &&
    process.env.NODE_ENV !== 'production';

  return (
    <div
      className={classnames(className, classes.root, {
        [classes.inline]: inline,
      })}>
      <div className={classes.section}>
        <div className={classes.icon}>
          <Error />
        </div>
        <div className={classes.content}>
          <p className={classes.title}>Whoops, something went wrong.</p>
          <p>
            Try loading this page again. If you continue to experience this
            issue,{' '}
            <a href="mailto:support@clearbit.com">contact Clearbit support</a>.
          </p>
        </div>

        <div className={classes.actions}>
          {loading && <CircularProgress className={classes.loadingIndicator} />}

          <CKButton
            className={classes.refetch}
            isDisabled={loading}
            variant="bold"
            variantColor="red"
            // Note: Important to call refetch() with no arguments, to avoid passing the mouse event
            onClick={refetch}>
            Try again
          </CKButton>
        </div>
      </div>
      {showDetails && (
        <div className={classnames(classes.section)}>
          <div className={classes.backtrace}>
            <p className={classes.title}>{networkErrorMessage}</p>
            <p className={classes.title}>{error.message}</p>

            {backtrace && (
              <ul className={classes.errorBacktrace}>
                {backtrace.map((line, index) => (
                  <li key={`${line} ${index}`}>{line}</li>
                ))}
              </ul>
            )}
          </div>
          <div className={classes.actions}>
            <div className={classes.badge}>Internal stack trace</div>
          </div>
        </div>
      )}
    </div>
  );
};

GraphqlError.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  error: PropTypes.shape({
    message: PropTypes.string,
    networkError: PropTypes.shape({
      result: PropTypes.shape({
        error: PropTypes.shape({
          backtrace: PropTypes.arrayOf(PropTypes.string),
        }),
      }),
    }),
  }),
  inline: PropTypes.bool,
  loading: PropTypes.bool,
  refetch: PropTypes.func,
};

export default withStyles(styles)(GraphqlError);
